export const loadingBlackList = [
  '/merchant/byNo',
  '/merchant/wallet/type',
  '/orderRecord/count',
  '/channel/type',
  '/sysCompany/page',
  '/walletRecord/amount/count',
  '/channelConf/support',
  '/channelType/page',
  '/orderRecord/payout/count',
  '/withdraw/count',
  '/withdraw/usdt/count',
  '/merchant/usdt/count',
  '/device/support/banks?type=1',
  '/device/support/banks?type=2',
  '/device/support/banks?type=3',
  '/device/transTypes',
  '/devices/histrans/momo/statistics',
  '/sys/pay/bank/statistics',
  '/export/progress'
];



// WEBPACK FOOTER //
// ./src/common/index.js